import { IContentCard } from '@models/IContentCard';
import ContentCard from '@molecules/ContentCard/ContentCard';
import SoftLoadWrapper from '@molecules/SoftLoadWrapper/SoftLoadWrapper';
import { useMemo } from 'react';

interface Props {
  readonly cards: IContentCard[];
  readonly showMoreLabel: string;
  readonly showLessLabel: string;
  readonly title?: string;
  readonly anchorId?: string;
}

const ContentCards = ({
  cards,
  showMoreLabel,
  showLessLabel,
  title,
  anchorId = '',
}: Props) => {
  const classArray = useMemo(() => {
    let res: string[] = [];

    const layoutArray = {
      2: [2],
      3: [3],
      4: [2, 2],
      5: [2, 3],
    }[cards.length];

    if (!layoutArray) return [];

    const classes = ['col-span-full', 'col-span-6', 'col-span-4'];
    layoutArray.forEach((row) => {
      const rowClasses = new Array(row).fill(classes[row - 1]);
      res = [...res, ...rowClasses];
    });

    return res;
  }, [cards]);

  return (
    <section
      className="component-padding bg-white text-black-100 dark:bg-black-100 dark:text-white"
      data-testid="CT-74-Content-Cards"
      id={`a-${anchorId}`}
    >
      <SoftLoadWrapper>
        {title && (
          <div className="container mb-10 flex items-center justify-center lg:mb-15">
            <h2
              className="h3 text-center lg:w-4/5"
              data-testid="CT-74-Content-Cards-Title"
            >
              {title}
            </h2>
          </div>
        )}

        <div className="container xl:grid xl:grid-cols-12">
          <div
            className="xl:col-span-full"
            data-testid="listingCardBlockPrimary"
          >
            <div
              className="flex flex-col gap-x-0 gap-y-[5.625rem] md:gap-x-4 lg:grid lg:grid-cols-12 dark:text-white"
              data-testid="content-card-listing"
            >
              {cards.map((card, index) => (
                <div className={classArray[index]} key={card.title}>
                  <ContentCard
                    {...card}
                    dataTestId={`CT-74-Content-Card-${index}`}
                    largeCard={classArray[index] === 'col-span-6'}
                    showMoreLabel={showMoreLabel}
                    showLessLabel={showLessLabel}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </SoftLoadWrapper>
    </section>
  );
};

export default ContentCards;
